import React from "react";
import "./delayMarkingAlertMsgPopup.scss";
import success_tick_pink from "../../../assets/success_tick_pink.svg";

export default function DelayMarkingAlertMsgPopup(props) {
  const { alertMsg } = props;

  return (
    <div className="delay-marking-message-toaster">
      <img src={success_tick_pink} alt="" style={{ marginRight: "10px" }} />{" "}
      {alertMsg}
    </div>
  );
}
